import { Locale } from 'date-fns';
import { enUS } from 'date-fns/locale';

export const getFnsLocale = (lng: string | undefined): Locale | undefined => {
  if (lng === 'en') return enUS;
  return undefined;
};
